<app-service-settings-common
    [defaultData]="store.voucherSettings()"
    [hideShareWithOtherServicesInput]="true"
    [title]="'service.settings.voucher.header'"
>
    <ng-template #additionalContent>
        <p-divider></p-divider>
        <app-check-input
            id="usePlanAndEvaluation"
            [form]="form"
            label="service.settings.voucher.usePlanAndEvaluation"
        ></app-check-input>
        @if (false) {
            <app-text-input
                id="emailToUserWhenVoucherChanges"
                [form]="form"
                label="service.settings.voucher.emailToUserWhenVoucherChanges"
            ><!-- TODO: zatim nezobrazovat, dodela se pozdeji --></app-text-input>
        }
    </ng-template>
    <ng-template #footer>
        <app-action-buttons
            (primaryClickEvent)="save()"
            (secondaryClickEvent)="cancel()"
        ></app-action-buttons>
    </ng-template>
</app-service-settings-common>
